// pages/SignInScreen.jsx
import React, { useEffect, useState } from "react";
import { auth, provider, db } from "../services/firebase";
import { signInWithPopup, onAuthStateChanged } from "firebase/auth";
import { ref, get } from "firebase/database";
import { useNavigate } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./SignInScreen.css";
import SendReviewAlertModal from "../components/SendReviewAlertModal";

export default function SignInScreen() {
    const [checking, setChecking] = useState(true);
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);

    const [hours, setHours] = useState("00");
    const [minutes, setMinutes] = useState("00");
    const [seconds, setSeconds] = useState("00");

    useEffect(() => {
        const timer = setInterval(() => {
            const now = new Date();

            // Next midnight
            const midnight = new Date();
            midnight.setHours(24, 0, 0, 0);

            const diff = midnight - now;

            const h = String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, "0");
            const m = String(Math.floor((diff / (1000 * 60)) % 60)).padStart(2, "0");
            const s = String(Math.floor((diff / 1000) % 60)).padStart(2, "0");

            setHours(h);
            setMinutes(m);
            setSeconds(s);
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                const profileRef = ref(db, `Users/Profile/${user.uid}`);
                const snapshot = await get(profileRef);

                if (snapshot.exists()) {
                    navigate("/user/packs", { replace: true });
                } else {
                    navigate("/user/profile", { replace: true });
                }
            }
            setChecking(false);
        });

        return () => unsubscribe();
    }, [navigate]);

    if (checking) return <p className="loading-text">Loading...</p>;

    const handleGoogleSignIn = async () => {
        try {
            const result = await signInWithPopup(auth, provider);
            const user = result.user;

            const profileRef = ref(db, `Users/Profile/${user.uid}`);
            const snapshot = await get(profileRef);

            if (snapshot.exists()) {
                navigate("/user/packs");
            } else {
                navigate("/user/profile");
            }
        } catch (error) {
            console.error("Sign-in failed", error);
        }
    };

    const testimonials = [
        {
            name: "Rahul Mehta",
            role: "Android Developer / Bangalore",
            text: "Interview Buster’s Android questions are spot-on. The questions on ViewModel, LiveData, Coroutines and Jetpack were exactly what I faced in my real interview at a startup.",
        },
        {
            name: "Harshita Sharma",
            role: "Kotlin Android Developer / Jaipur",
            text: "I loved how even the toughest Android questions had full explanations. The Fragment backstack and ViewModel scope answers helped me clear a senior developer round.",
        },
        {
            name: "Aakash Tiwari",
            role: "Android Engineer / Noida",
            text: "The advanced questions on Jetpack, Clean Architecture, and state management were amazing. Every difficult question had a proper breakdown, not just one-line answers.",
        },
        {
            name: "Sneha Patil",
            role: "Android Fresher / Pune",
            text: "As a fresher, I was confused about what Android topics companies actually ask. This platform gave me real interview-style questions and I felt confident in my first round.",
        },
        {
            name: "Pratik Singh",
            role: "Android Intern / Noida",
            text: "The best part is comparing my answer with the ideal explanation. I understood how to structure answers for RecyclerView, MVVM and Activity lifecycle questions.",
        },
        {
            name: "Nisha Reddy",
            role: "Junior Android Developer / Hyderabad",
            text: "The Android interview tests felt like real company rounds. I liked the one-question-at-a-time format. Cleared my interview at a mid-sized product company after practicing here.",
        },
        {
            name: "Aman Verma",
            role: "Kotlin Developer / Delhi",
            text: "Amazing for Android preparation. The Kotlin Coroutines, Flow and Clean Architecture questions were very similar to what I got in my technical round.",
        },
        {
            name: "Varun Kapoor",
            role: "Mobile App Developer / Mumbai",
            text: "The explanations helped me correct my understanding of Fragment lifecycle and Navigation Component. Great platform for Android-focused interviews.",
        },
        {
            name: "Deepika Rao",
            role: "BCA Student / Chennai",
            text: "Very useful for students preparing Android interviews. The questions are practical and not theory-based like Google search results.",
        },
        {
            name: "Hitesh Gupta",
            role: "Android Engineer / Gurgaon",
            text: "If you want solid Android interview prep, this is perfect. Covers Room DB, WorkManager, Jetpack Compose and Kotlin basics in a practical way.",
        },
        {
            name: "Ajay Prasad",
            role: "Android App Developer / Kolkata",
            text: "Some questions were tricky, especially on activity launch modes and process death. But the full-length explanation helped me answer similar questions in my real interview.",
        }
    ];


    return (
        <>
            <header className="ci-header">
                <div className="ci-left" onClick={() => navigate("/")}>
                    <span
                        className="ci-brand">Interview Buster</span>
                </div>

                <nav className={`ci-nav ${menuOpen ? "open" : ""}`}>
                  
                    <button
                        className="ci-nav-btn"
                        onClick={() => {
                            if (!auth.currentUser) {
                                setShowAlert(true);
                                return;
                            }
                            navigate("/user/send-review");
                        }}
                    >
                         Send Review
                    </button>

                    <button
                        className="ci-nav-btn"
                        onClick={() => navigate("/about")}>About

                    </button>
                    <button className="ci-nav-btn"
                        onClick={() => navigate("/faq")}
                    >FAQ</button>
                    <button
                        className="ci-nav-btn"
                        onClick={() => navigate("/contact")}>Contact Us
                    </button>
                    <button
                        className="ci-primary"
                        onClick={handleGoogleSignIn}>Sign In
                    </button>
                </nav>

                <button
                    className={`ci-hamburger ${menuOpen ? "active" : ""}`}
                    onClick={() => setMenuOpen(s => !s)}
                >
                    <span />
                    <span />
                    <span />
                </button>
            </header>

            <div className="header-container">
                <h2>
                    Don't go for a company interview before completing your interview practice here.
                </h2>
            </div>

            <div className="offer-timer-box">
                <h3 className="offer-title">
                    🔥 Flat 50% OFF Today Only — Offer Ends In:
                </h3>
                <div className="offer-timer">
                    {hours} : {minutes} : {seconds}
                </div>
            </div>


            <main className="signin-main">
                <section className="benefit-container">
                    <h1 className="benefit-title">Why Interview Buster?</h1>

                    <ul className="benefit-points">
                        <li>Practice 100% real interview questions</li>
                        <li>All questions are from real candidates</li>
                        <li>Perfect for all levels — whether you're a fresher or an experienced Android developer.</li>
                        <li>Choose domain & experience</li>
                        <li>10 interview-style tests per pack</li>
                        <li>Attempt tests like real interviews</li>
                        <li>Attempt the test at your convenience — but it is highly recommended to complete it before your actual interview.</li>
                        <li>Boost your hiring chances</li>
                    </ul>

                    <p
                        onClick={handleGoogleSignIn}
                        className="benefit-cta">Sign in to start your journey 🚀
                    </p>
                </section>

                <aside className="signin-card">
                    <h2>Welcome</h2>
                    <p>Sign in to continue</p>

                    <button className="google-btn" onClick={handleGoogleSignIn}>
                        <img src="https://developers.google.com/identity/images/g-logo.png" alt="" />
                        Sign in with Google
                    </button>

                    <p className="footer-text">Your success story starts here</p>
                </aside>
            </main>

            <div className="screenshot-section">

                <div className="screenshot-inner">

                    <h2 className="section-title">See How Your Interview Test Looks</h2>
                    <p className="section-para">Respond using your voice or by typing — both are supported.</p>

                    <img src="/images/question_shot_1.png" className="homepage-screenshot" alt="..." />
                    <img src="/images/question_shot_2.png" className="homepage-screenshot" alt="..." />

                    {/* Your restored text */}
                    <h2 className="section-title">Interview Result & Explanation Looks</h2>

                    <div className="result-box">

                        <ul className="section-list">
                            <li>Compare your answer with the ideal solution.</li>
                            <li>Check your answer accuracy with points.</li>
                            <li>Get instant feedback and improvement tips.</li>
                        </ul>
                    </div>

                    <img src="/images/answer_shot_1.png" className="homepage-screenshot" alt="..." />
                    <img src="/images/answer_shot_2.png" className="homepage-screenshot" alt="..." />
                </div>
            </div>


            {/* ---------- TESTIMONIAL SECTION ---------- */}
            <div className="testimonial-section">
                <div>
                    <h1 className="review-header">User Reviews</h1>
                </div>
                <Swiper
                    modules={[Navigation, Pagination]}
                    navigation
                    pagination={{ clickable: true }}
                    spaceBetween={30}
                    slidesPerView={1}
                    breakpoints={{ 768: { slidesPerView: 2 }, 1024: { slidesPerView: 3 } }}
                >
                    {testimonials.map((t, i) => (
                        <SwiperSlide key={i}>
                            <div className="testimonial-card">
                                <div className="testimonial-name">{t.name}</div>
                                <div className="testimonial-role">{t.role}</div>
                                <div className="stars">★★★★★</div>
                                <p className="testimonial-text">{t.text}</p>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>


            {showAlert && (
                <SendReviewAlertModal
                    title="Sign In Required"
                    message="Please sign in to send a review."
                    onClose={() => { 
                        setShowAlert(false)
                    }}
                />
            )}

        </>
    );
} 
